import { useState } from "react";
import { fetchTatvaShots } from "../pages/tatvaShots/service";
import useStore from "../store/useStore";
import useUserPreferences from "./usePreferences";

const useShots = () => {
  const { tatvaShots, setTatvaShots } = useStore();
  const { getUserPreferences } = useUserPreferences();
  const [loader, setLoader] = useState(false);

  const getShots = async (
    type:
      | "myFeed"
      | "trending"
      | "allNews"
      | "bookmarks"
      | "topicNews"
      | "shotTags",
    pageNumber = 0,
    pageSize = 11,
    topic?: any,
    reset = true
  ) => {
    try {
      setLoader(true);
      let userPreferences = tatvaShots.userPreferences;
      if (
        (type === "myFeed" || type === "trending") &&
        !tatvaShots.userPreferences?.length
      ) {
        userPreferences = await getUserPreferences();
      }
      const res: any = await fetchTatvaShots(
        {
          ...(type === "myFeed" ||
          type === "trending" ||
          type === "allNews" ||
          type === "topicNews" ||
          type === "shotTags"
            ? {
                specialities:
                  type === "allNews" ||
                  type === "topicNews" ||
                  type === "trending" ||
                  type === "shotTags"
                    ? []
                    : userPreferences?.map(({ id }: any) => ({ id })),
              }
            : {}),
          ...(type === "bookmarks" ? { isBookmarked: true } : {}),
          categories: [],
          allNews:
            type === "allNews" || type === "topicNews" || type === "shotTags",
          isTrending: type === "trending",
          isViewed: type === "bookmarks",
          ...((type === "topicNews" || type === "allNews") && {
            topics: type === "topicNews" && topic ? [{ id: topic }] : [],
          }),
          ...((type === "shotTags" ||
            type === "allNews" ||
            type === "topicNews") && {
            shotTags: topic && type === "shotTags" ? [{ id: topic }] : [],
          }),
        },
        {
          page: pageNumber,
          size: pageSize,
        }
      );
      setLoader(false);
      setTatvaShots({
        [type]: reset
          ? res?.dtoList
          : [...(tatvaShots[type] || []), ...(res?.dtoList || [])],
      });
      return res?.dtoList;
    } catch (err) {
      // Handle error
      console.error("Error fetching shots:", err);
    }
  };

  return { getShots, loader };
};

export default useShots;
